<h2 mat-dialog-title>
  {{ 'PRODUCT.USERADMIN.DIALOG_CANCEL.cancel_editing' | translate }}
</h2>
<mat-dialog-content>
  <p>
    {{
      'PRODUCT.USERADMIN.DIALOG_CANCEL.confirm_cancel_editing'
        | translate: { data: data() }
    }}
  </p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button mat-dialog-close>
    {{ 'PRODUCT.USERADMIN.DIALOG_CANCEL.continue_editing' | translate }}
  </button>
  <button
    mat-raised-button
    class="btn-app-cancel"
    [mat-dialog-close]="true"
    cdkFocusInitial>
    {{ 'PRODUCT.USERADMIN.DIALOG_CANCEL.exit_without_saving' | translate }}
  </button>
</mat-dialog-actions>
